import { memo, MouseEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import Colorizr, { hsl2hex } from 'colorizr';

import styles from './Logo.module.css';

interface LogoProps {
  instance: Colorizr;
}

function Logo(props: LogoProps) {
  const { instance } = props;
  const navigate = useNavigate();

  const handleClick = (event: MouseEvent<SVGPathElement>) => {
    const fill = event.currentTarget.getAttribute('fill');

    navigate(`/${fill}`);
  };

  const backupColor = instance.lightness < 30 ? '#FFF' : '#333';

  return (
    <div className={styles.main} data-component-name="Logo">
      <svg
        enableBackground="new 0 0 400 70"
        preserveAspectRatio="xMinYMin meet"
        version="1.1"
        viewBox="0 0 400 70"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M44.3 38.2c-.4 3.4-1.3 6.3-2.8 8.7-1.5 2.5-3.3 4.5-5.5 6.1-2.1 1.6-4.5 2.8-7.1 3.5s-5.2 1-7.9.9c-2.7-.2-5.3-.7-7.8-1.7s-4.8-2.4-6.7-4.3c-2-1.9-3.5-4.2-4.7-6.9-1.2-2.8-1.8-6-1.8-9.6 0-3.6.6-6.8 1.8-9.5 1.2-2.7 2.8-5 4.7-6.9 2-1.9 4.2-3.3 6.7-4.3s5.1-1.6 7.8-1.7c2.7-.1 5.3.2 7.9.9s5 1.9 7.1 3.5c2.1 1.6 4 3.6 5.4 6.1 1.5 2.5 2.4 5.4 2.8 8.7H31.6c-.5-1.7-1.3-3.2-2.4-4.3-1.1-1.1-2.4-1.9-3.8-2.4s-2.9-.6-4.4-.4c-1.5.2-2.9.7-4.2 1.5-1.3.8-2.3 2-3.1 3.5-.8 1.5-1.2 3.3-1.2 5.4 0 2.1.4 3.9 1.2 5.4.8 1.5 1.9 2.7 3.1 3.5 1.3.8 2.7 1.4 4.2 1.5 1.5.2 3 .1 4.4-.4 1.4-.5 2.7-1.3 3.8-2.4 1.1-1.1 1.9-2.6 2.4-4.3h12.7zM92.1 34.9c0 3.8-.7 7.1-2 9.9-1.3 2.8-3 5.2-5.2 7.1-2.1 1.9-4.6 3.3-7.3 4.3-2.7.9-5.5 1.4-8.3 1.4-2.8 0-5.6-.5-8.3-1.4-2.7-.9-5.1-2.4-7.3-4.3-2.1-1.9-3.9-4.3-5.2-7.1-1.3-2.8-2-6.1-2-9.9 0-3.8.6-7.1 2-10 1.3-2.8 3-5.2 5.2-7.1 2.1-1.9 4.6-3.3 7.3-4.3 2.7-.9 5.5-1.4 8.3-1.4 2.8 0 5.6.5 8.3 1.4 2.7.9 5.1 2.4 7.3 4.3 2.1 1.9 3.9 4.3 5.2 7.1 1.3 2.9 2 6.3 2 10zm-32.7 0c0 2.3.5 4.3 1.5 5.8s2.2 2.7 3.7 3.5c1.5.8 3.1 1.2 4.8 1.2s3.3-.4 4.8-1.2c1.5-.8 2.7-2 3.7-3.5s1.5-3.5 1.5-5.8-.5-4.3-1.5-5.9c-1-1.6-2.2-2.7-3.7-3.5-1.5-.8-3.1-1.2-4.8-1.2s-3.3.4-4.8 1.2c-1.5.8-2.7 2-3.7 3.5-1 1.7-1.5 3.6-1.5 5.9zM108.7 0v56.9h-13V0h13zM157.3 34.9c0 3.8-.7 7.1-2 9.9-1.3 2.8-3 5.2-5.2 7.1-2.1 1.9-4.6 3.3-7.3 4.3-2.7.9-5.5 1.4-8.3 1.4-2.8 0-5.6-.5-8.3-1.4-2.7-.9-5.1-2.4-7.3-4.3-2.1-1.9-3.9-4.3-5.2-7.1-1.3-2.8-2-6.1-2-9.9 0-3.8.6-7.1 2-10 1.3-2.8 3-5.2 5.2-7.1 2.1-1.9 4.6-3.3 7.3-4.3 2.7-.9 5.5-1.4 8.3-1.4 2.8 0 5.6.5 8.3 1.4 2.7.9 5.1 2.4 7.3 4.3 2.1 1.9 3.9 4.3 5.2 7.1 1.3 2.9 2 6.3 2 10zm-32.7 0c0 2.3.5 4.3 1.5 5.8s2.2 2.7 3.7 3.5c1.5.8 3.1 1.2 4.8 1.2s3.3-.4 4.8-1.2c1.5-.8 2.7-2 3.7-3.5s1.5-3.5 1.5-5.8-.5-4.3-1.5-5.9c-1-1.6-2.2-2.7-3.7-3.5-1.5-.8-3.1-1.2-4.8-1.2s-3.3.4-4.8 1.2c-1.5.8-2.7 2-3.7 3.5-1 1.7-1.5 3.6-1.5 5.9zM173.5 32.5v24.4h-12.8v-44h11.5l.5 2.9c2.1-2 4.3-3.1 6.7-3.6 2.4-.4 5-.3 7.8.4l-.2 12c-1.4-.4-2.8-.6-4.4-.6-1.6 0-3.1.3-4.4.9-1.4.6-2.5 1.5-3.4 2.7-.8 1.4-1.3 3-1.3 4.9z"
          fill={
            instance.saturation > 8
              ? hsl2hex({
                  h: (instance.hue + 90) % 360,
                  s:
                    instance.saturation < 30
                      ? Math.abs(instance.saturation + 30)
                      : instance.saturation,
                  l: instance.lightness < 35 ? instance.lightness + 20 : instance.lightness,
                })
              : backupColor
          }
          fillOpacity={instance.saturation < 10 ? 0.6 : 1}
          onClick={handleClick}
        />
        <path
          d="M190.8 12.9h12.9v4.4c1.6-2 3.4-3.3 5.6-4 2.2-.7 4.4-1.1 6.8-1 2.5.1 4.6.7 6.3 1.7s3 2.4 4 4.1c1.5-2.1 3.5-3.6 5.9-4.5 2.4-.9 4.9-1.4 7.5-1.3 2.1.1 4 .5 5.8 1.3 1.8.8 3.4 1.9 4.8 3.5s2.4 3.6 3.2 6.1c.8 2.5 1.1 5.4 1.1 8.9v24.8h-12.9V32.2c0-2.7-.5-4.5-1.6-5.6-1.1-1.1-2.4-1.7-3.8-1.7-.8 0-1.6.1-2.4.4-.8.3-1.5.7-2.2 1.3s-1.2 1.3-1.6 2.2c-.4.9-.7 1.9-.7 3.1v25h-13V32.2c0-2.7-.5-4.5-1.6-5.6-1.1-1.1-2.4-1.7-3.8-1.7-.8 0-1.6.1-2.4.4-.8.3-1.5.7-2.2 1.3-.7.6-1.2 1.3-1.6 2.2s-.6 2-.6 3.2v24.9h-13.6v-44zM303.6 34.8c0 1.7-.2 3.4-.5 5h-31.5c.6 1.7 1.7 3.1 3.1 4.1 1.4 1 3 1.6 4.6 1.9 1.7.3 3.3.2 5-.3 1.7-.5 3-1.3 4.1-2.5h13.9c-1.2 3.6-3.2 6.6-5.9 8.8-2.7 2.2-5.6 3.8-8.9 4.7-3.3.9-6.7 1.1-10.1.7-3.5-.5-6.6-1.6-9.5-3.4-2.8-1.8-5.2-4.3-7-7.5-1.8-3.2-2.8-7-2.8-11.5 0-3.7.7-7 2-9.8 1.3-2.8 3-5.2 5.2-7.1 2.1-1.9 4.6-3.3 7.3-4.2 2.7-.9 5.5-1.4 8.3-1.4 2.8 0 5.6.5 8.3 1.4 2.7.9 5.1 2.3 7.3 4.2 2.1 1.9 3.9 4.3 5.2 7.1 1.3 2.8 1.9 6 1.9 9.8zm-14-5c-.6-2.2-1.7-3.8-3.4-4.9-1.7-1-3.5-1.5-5.6-1.5-1.9 0-3.6.5-5.2 1.6s-2.7 2.7-3.4 4.8h17.6z"
          fill={
            instance.saturation > 8
              ? hsl2hex({
                  h: (instance.hue + 180) % 360,
                  s:
                    instance.saturation < 30
                      ? Math.abs(instance.saturation + 30)
                      : instance.saturation,
                  l: instance.lightness < 35 ? instance.lightness + 20 : instance.lightness,
                })
              : backupColor
          }
          fillOpacity={instance.saturation < 10 ? 0.4 : 1}
          onClick={handleClick}
        />
        <path
          d="M348.5 56.9h-12.9v-4.5c-1.6 2-3.4 3.4-5.6 4.1-2.2.7-4.4 1-6.8 1-3.1 0-5.7-.6-7.8-1.7-2-1.1-3.7-2.6-4.9-4.4-1.2-1.8-2.1-4-2.5-6.5-.5-2.5-.7-5.1-.7-7.8V12.9h12.9V37c0 2.2.4 3.9 1.1 5.2.7 1.3 1.6 2.3 2.7 2.8 1.1.6 2.3.8 3.5.7 1.3-.1 2.5-.5 3.5-1.3 1.1-.7 2-1.7 2.7-3s1.1-2.9 1.1-4.7V12.9h13.6v44zM377.4 57.6c-2.2 0-4.2-.4-6.2-1.1-2-.8-3.7-2-5.2-3.7v16.9h-12.7V12.9H366v4.4c1.5-1.9 3.3-3.2 5.3-3.9 2-.7 4.1-1.1 6.2-1.1 3.5 0 6.5.7 9.2 2 2.7 1.3 4.9 3 6.7 5.2 1.8 2.1 3.1 4.6 4 7.4.9 2.8 1.3 5.7 1.3 8.8-.1 3-.5 5.9-1.4 8.5-.9 2.7-2.2 5-4 6.9-1.8 2-4 3.5-6.6 4.7-2.6 1.2-5.7 1.8-9.3 1.8zm-1.4-33c-1.4 0-2.7.3-3.9.8-1.2.5-2.2 1.3-3.2 2.3-.9 1-1.6 2.1-2.2 3.4-.5 1.3-.8 2.6-.8 4.1s.3 2.8.8 4.1c.5 1.3 1.2 2.4 2.2 3.4.9.9 2 1.7 3.2 2.3 1.2.6 2.5.9 3.9.9 1.6 0 3-.3 4.3-.9 1.2-.6 2.2-1.4 3-2.4.8-1 1.4-2.1 1.9-3.4.4-1.3.7-2.6.7-3.9s-.2-2.6-.6-3.9-1-2.5-1.8-3.5-1.8-1.8-3.1-2.4c-1.3-.6-2.7-.9-4.4-.9z"
          fill={
            instance.saturation > 8
              ? hsl2hex({
                  h: (instance.hue + 270) % 360,
                  s:
                    instance.saturation < 30
                      ? Math.abs(instance.saturation + 30)
                      : instance.saturation,
                  l: instance.lightness < 35 ? instance.lightness + 20 : instance.lightness,
                })
              : backupColor
          }
          fillOpacity={instance.saturation < 10 ? 0.2 : 1}
          onClick={handleClick}
        />
      </svg>
    </div>
  );
}

export default memo(Logo);
